export const GET_UPLOAD_CUSTOM_CDN = 'GET_UPLOAD_CUSTOM_CDN';
export const SET_UPLOAD_CUSTOM_CDN = 'SET_UPLOAD_CUSTOM_CDN';
export const GET_UPLOAD_CUSTOM_CDN_ERROR = 'GET_UPLOAD_CUSTOM_CDN_ERROR';

export const GET_UPLOAD_SHORTENER = 'GET_UPLOAD_SHORTENER';
export const SET_UPLOAD_SHORTENER = 'SET_UPLOAD_SHORTENER';
export const GET_UPLOAD_SHORTENER_ERROR = 'GET_UPLOAD_SHORTENER_ERROR';
